import gql from "graphql-tag";

export default gql`query Types {
    types {
        id
        name
        allowMany
    }
}`